export const enum AuditState {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  WAITING = 'WAITING'
}
// 列表
export interface ITableType {
  houseName?: string; // 房源名称
  fyUserType?: number; // 分佣用户类型 1 中介
  visible?: boolean; // 可否报备
  description?: string; // 描述
}

export const defaultValue: Readonly<ITableType> = {};

// 搜索表单
export interface ISearchForm {
  name?: string;
}

export const defaultSearchForm: ISearchForm = {
  name: ''
};
